import { motion, AnimatePresence } from 'motion/react';
import { useState } from 'react';
import { FocusCard } from '@/components/FocusCard';
import { SuggestionChips } from '@/components/SuggestionChips';
import { FreeTextInput } from '@/components/FreeTextInput';
import { ProgressIndicator } from '@/components/ProgressIndicator';
import { BackButton } from '@/components/BackButton';
import { SyncButton } from '@/components/SyncButton';
import { SyncLog } from '@/components/SyncLog';

export function FocusView() {
  const [showSyncLog, setShowSyncLog] = useState(false);

  const handleSync = async () => {
    // Simulate sync with Hermes
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // In real implementation, this would call the Hermes connector
    // For now, simulate success
    return { 
      success: true, 
      message: 'Session synced successfully. 3 cards updated, 1 new answer pushed.' 
    };
  };

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <header className="flex h-16 items-center justify-between px-6 border-b border-border">
        <h1 className="text-xl font-semibold">Focus</h1>
        <div className="flex items-center gap-2">
          <ProgressIndicator progress={0.3} />
          <SyncButton sessionId="current-session" onSync={handleSync} />
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-6 overflow-y-auto">
        <div className="w-full max-w-3xl">
          <AnimatePresence mode="wait">
            <motion.div
              key="focus-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
            >
              <FocusCard
                title="Deep Work Session"
                description="Complete the authentication module implementation"
                timeRemaining={45 * 60} // 45 minutes in seconds
                onComplete={() => console.log('Session complete')}
                onPause={() => console.log('Session paused')}
              />
            </motion.div>
          </AnimatePresence>

          <div className="mt-6">
            <SuggestionChips
              suggestions={[
                'Extend session by 15 min',
                'Switch to review mode',
                'Log distraction',
                'Take a break',
              ]}
              onSelect={(suggestion) => console.log('Selected:', suggestion)}
            />
          </div>

          <div className="mt-6">
            <FreeTextInput
              placeholder="Add a note or thought..."
              onSubmit={(text) => console.log('Note:', text)}
            />
          </div>
        </div>
      </main>

      {/* Footer actions */}
      <footer className="flex h-16 items-center justify-between px-6 border-t border-border">
        <BackButton onClick={() => console.log('Back')} />
        <div className="flex items-center gap-3">
          <button className="btn-secondary">Pause</button>
          <button className="btn-primary">Complete</button>
        </div>
      </footer>

      {/* Sync Log Modal */}
      <AnimatePresence>
        {showSyncLog && (
          <SyncLog sessionId="current-session" onClose={() => setShowSyncLog(false)} />
        )}
      </AnimatePresence>
    </div>
  );
}